import { render, staticRenderFns } from "./Imggs.vue?vue&type=template&id=409c415b&"
import script from "./Imggs.vue?vue&type=script&lang=js&"
export * from "./Imggs.vue?vue&type=script&lang=js&"
import style0 from "./Imggs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports